import PromotionalBannerImage from './PromotionalBannerImage';

export default PromotionalBannerImage;
